/** @jsx jsx */
import { Col } from '@bottlebooks/gatsby-theme-base/src';
import { jsx } from 'theme-ui';
import ProductImage from '../Product/ProductImage';

export { ProductImageFragment_large } from '../Product/ProductImage';

export default function ProductImageCol({ product, overlap = false, ...rest }) {
  return (
    <Col sx={overlap && { marginTop: [-143, -90] }} {...rest}>
      <ProductImage
        size="large"
        product={product}
        sx={{ boxShadow: `border`, backgroundColor: 'background', padding: 2 }}
      />
    </Col>
  );
}
